import React from "react";
import { Box, Typography, Avatar, useMediaQuery } from "@mui/material";
import elena from "../assets/elena.png"; // Ensure this path is correct
import ReactMarkdown from "react-markdown";

export interface ChatBubbleProps {
	text: string;
	isResponse: boolean; // true for Elena's response, false for question
	audioUrl?: string; // Add this line
}

const ChatBubble: React.FC<ChatBubbleProps> = ({
	text,
	isResponse,
	audioUrl,
}) => {
	const avatarStyle = {
		width: 40,
		height: 40,
		bgcolor: isResponse ? "transparent" : "grey",
		marginRight: 2,
		display: "inline-flex",
		verticalAlign: "middle",
	};
	const isMobile = useMediaQuery("(max-width:600px)");

	return (
		<Box
			sx={{
				marginBottom: 2,
				paddingX: isMobile ? 2 : 5,
				display: "flex",
			}}
		>
			{/* User Box */}
			<Box sx={{ marginTop: 3 }}>
				{isResponse && (
					<Box display="flex" alignItems="center">
						<Avatar src={elena} alt="Elena" sx={avatarStyle} />
						<Typography variant="body1">Elena</Typography>
					</Box>
				)}
				{!isResponse && (
					<Box display="flex" alignItems="center">
						<Avatar sx={avatarStyle} />{" "}
						<Typography variant="body1">You</Typography>
					</Box>
				)}
				{isResponse && (
					<Box
						sx={{
							borderRadius: "20px",
							// bgcolor: isResponse ? "primary.light" : "secondary.light", // Change the colors as needed
							color: "000",
							wordWrap: "break-word",
							marginLeft: 1,
							textAlign: "left",
							marginTop: 1,
						}}
					>
						<ReactMarkdown>{text}</ReactMarkdown>
						<audio src={audioUrl} controls />
					</Box>
				)}
				{!isResponse && (
					<Typography
						variant="body1"
						sx={{
							borderRadius: "20px",
							color: "000",
							wordWrap: "break-word",
							marginLeft: 1,
							textAlign: "left",
							marginTop: 1,
						}}
					>
						{text}
					</Typography>
				)}
			</Box>
		</Box>
	);
};

export default ChatBubble;
